export default __webpack_public_path__ + "static/char-16-d029413b358d97ebe118872ef1467a88.gif";